module.exports = __webpack_public_path__ + "img/049ca01.jpg";